import React from 'react';

import ProjectIconUI5 from "../icons/project/project-icon-ui5";
import ProjectSession from "../../model2/project/project-session";
import HintPopover from "../../gd-ui/hint-popover/hint-popover"

type Props =  {
    className?              : string
    style?                  : any

    projectId               : ID
    maxParents?             : number    // Maximum number of parent projects to display in the breadcrumb trail
    enableOverflowEllipsis? : boolean   // If true, shows ellipsis ("...") when actual number of parent projects exceeds maxParents

    showIcon?               : boolean
    colorize?               : boolean
    disabled?               : boolean
    hintFullPath?           : boolean

    onClickProject?         : callback
}

// const debug = "BreadcrumbsUI5"
const debug = false

export default class BreadcrumbsUI5 extends React.Component<Props> {

    static defaultProps = {
        showIcon    : true,
        colorize    : true,

        // maxParents  : 3, done below
    }

    onClickProject = (e:React.SyntheticEvent, project:ProjectSession) => {
        debug && console.log(debug, 'onClickProject', project)

        if (!project.access) return

        if(!this.props.disabled) {
            e.stopPropagation();

            if (this.props.onClickProject) {
                this.props.onClickProject(project.id);
            } else {
                // gd.goTo('p/{0}'.f(project.id));
                project.goTo()

                if (!!project.space.navigation.onClick) {
                    project.space.navigation.onClick(project.space.navigation)
                }

            }
        }
    }

    getHint = () => {
        let res

        if (this.props.projectId) {
            const project : ProjectSession | null = gd.session.projects.get(this.props.projectId)
            const parents: string[] = _.map(project?.path, (pathProject : ProjectSession) => {
                return pathProject.name
            })

            res = parents.join(' / ')
        }

        return res
    }

    render() {
        const maxParents = this.props.maxParents || 3
        const project : ProjectSession | null = gd.session.projects.get(this.props.projectId)

        const projects              : any[] = []
        const breadcrumbs           : any[] = []
        let isOverflowingMaxParents : boolean = false

        _.some(project?.path.reverse(), (project: ProjectSession, key : number)=>{
            if (key > maxParents) {
                isOverflowingMaxParents = true
                return true
            }

            if (project) {
                projects.push(project)
            }
        })

        _.map(projects, (project: ProjectSession, key: number)=>{
            if (key === 0) {
                const itemMinWidth = _.min([gd.utils.getTextWidth(project.name) + (this.props.showIcon ? 20 : 0) + 1 /*width correction*/, 100])
                breadcrumbs.unshift(
                    <div key        = {key}
                         className  = "breadcrumb-item"
                         style      = {{minWidth: itemMinWidth}}
                         onClick    = {(e)=>{this.onClickProject(e, project)}}>
                        {this.props.showIcon &&
                            <ProjectIconUI5 className   = "item-icon m-r-5"
                                            projectId   = {project.id}
                                            colorize    = {this.props.colorize}/>}
                        <div className="label">{project.name}</div>
                    </div>
                )
            } else {
                breadcrumbs.unshift(
                    <React.Fragment key={key}>
                        <div className  = "breadcrumb-item"
                             onClick    = {(e)=>{this.onClickProject(e, project)}}><div className="label">{project.name}</div></div>
                        <div className="breadcrumb-separator"/>
                    </React.Fragment>
                )
            }
        })

        if (this.props.enableOverflowEllipsis && isOverflowingMaxParents) {
            breadcrumbs.unshift(
                <div key        = "dots"
                     className  = "breadcrumb-item">
                    <div className="label">...</div>
                    <div className="breadcrumb-separator"/>
                </div>
            )
        }

        const classes = Classes("ui5-breadcrumbs", this.props.className)

        return (
            <div className  = {classes}
                 style      = {this.props.style}
            >
                {breadcrumbs}
                {this.props.hintFullPath &&
                    <HintPopover hint       = {this.getHint()}
                                 multiline  = {true}
                                 showDelay  = {1000}/>}
            </div>
        )
    }
}
